import { initializeApp } from "firebase/app";
import {
  getDatabase,
  ref,
  onValue,
  push,
  set,
  serverTimestamp,
} from "firebase/database";

// Log environment variables for debugging
if (process.env.NODE_ENV === "development") {
  console.log("Firebase Environment Variables:");
  console.log(
    "API Key:",
    process.env.REACT_APP_FIREBASE_API_KEY
      ? process.env.REACT_APP_FIREBASE_API_KEY
      : "Missing"
  );
  console.log(
    "Auth Domain:",
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
      ? process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
      : "Missing"
  );
  console.log(
    "Database URL:",
    process.env.REACT_APP_FIREBASE_DATABASE_URL
      ? process.env.REACT_APP_FIREBASE_DATABASE_URL
      : "Missing"
  );
  console.log(
    "Project ID:",
    process.env.REACT_APP_FIREBASE_PROJECT_ID
      ? process.env.REACT_APP_FIREBASE_PROJECT_ID
      : "Missing"
  );
  console.log(
    "Storage Bucket:",
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
      ? process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
      : "Missing"
  );
  console.log(
    "Messaging Sender ID:",
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
      ? process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
      : "Missing"
  );
  console.log(
    "App ID:",
    process.env.REACT_APP_FIREBASE_APP_ID
      ? process.env.REACT_APP_FIREBASE_APP_ID
      : "Missing"
  );
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize variables for export
let db;
let refFunc = ref;
let onValueFunc = onValue;
let pushFunc = push;
let setFunc = set;
let serverTimestampFunc = serverTimestamp;

try {
  // Check if all required config values are present
  if (
    !firebaseConfig.apiKey ||
    !firebaseConfig.databaseURL ||
    !firebaseConfig.projectId
  ) {
    throw new Error("Missing required Firebase configuration values");
  }

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  db = getDatabase(app);
  console.log("Firebase initialized successfully");
} catch (error) {
  console.error("Firebase initialization error:", error);

  // Create a more robust mock implementation
  console.warn("Creating mock Firebase implementation");

  // Mock database object
  db = {
    _checkNotDeleted: function () {
      return true;
    },
    app: {
      name: "[DEFAULT]",
      options: { ...firebaseConfig },
    },
    INTERNAL: {
      getToken: () => Promise.resolve({ accessToken: "mock-token" }),
    },
  };

  // Mock ref function
  refFunc = function mockRef(db, path) {
    console.log(`Mock ref called with path: ${path}`);
    return {
      key: path ? path.split("/").pop() : null,
      path: path || "/",
      parent: null,
      _checkNotDeleted: function () {
        return true;
      },
    };
  };

  // Mock onValue function
  onValueFunc = function mockOnValue(reference, callback, errorCallback) {
    console.log(`Mock onValue called for path: ${reference.path}`);
    // Simulate empty data
    setTimeout(() => {
      try {
        callback({
          exists: () => false,
          val: () => null,
        });
      } catch (e) {
        if (errorCallback) errorCallback(e);
      }
    }, 100);

    // Return an unsubscribe function
    return () => console.log("Mock unsubscribe called");
  };

  // Mock push function
  pushFunc = function mockPush(reference) {
    console.log(`Mock push called for path: ${reference.path}`);
    return {
      key: `mock-key-${Date.now()}`,
      path: reference.path,
      _checkNotDeleted: function () {
        return true;
      },
    };
  };

  // Mock set function
  setFunc = function mockSet(reference, data) {
    console.log(`Mock set called for path: ${reference.path}`, data);
    return Promise.resolve();
  };

  // Mock serverTimestamp function
  serverTimestampFunc = function mockServerTimestamp() {
    return { ".sv": "timestamp" };
  };

  console.warn("Mock Firebase implementation ready");
}

export {
  db,
  refFunc as ref,
  onValueFunc as onValue,
  pushFunc as push,
  setFunc as set,
  serverTimestampFunc as serverTimestamp,
};
